import axios from 'axios'
import moment from "moment/moment";
const state = {
  pages: [],
  default_params: [],
  dateFrom: moment(new Date()).add(-100, 'year').format('DD.MM.YYYY'),
  dateTo: moment(new Date()).format('DD.MM.YYYY'),
  detailsPage: false,
  taskDetails: {
    selectedtrades: [],
    flawparams: []
  },
  taskDetailsDefaultParams: {
    flawparams: []
  },
  taskPhotos: [],
  taskTempPhotos: [],
  taskEditPhotos: [],
  servicesWithCompanies: [],
  tasksMetaDateFrom: '',
  tasksMetaDateTo: '',
  editTaskDetails: {
    selectedtrades: []
  },
  editTaskSelectedPhotos: [],
  isEdit: false,
  newTaskDetails: {
    created: "",
    creator: "",
    defaultflawparams: [],
    deleted: 0,
    description: "",
    donedate: "",
    flawdate: "",
    flawitems: [],
    flawname: "",
    flawparams: [],
    flawtrades: [],
    flawtype: 1,
    flawurl: "/backend/get?method=flaw&fid=1490",
    fristdate: "",
    noticedate: new Date(),
    notifiedate: "",
    pdflawflags: [],
    pdflawid: 0,
    pdflawstatusrows: [],
    pdprojectid: null,
    pduserid: 0,
    planitems: null,
    projectid: 171,
    responsibleuser: null,
    runid: 0,
    secondfristdate: "0000-00-00",
    selectedtrades: [],
    status: 2,
   _explicitType: "com\\projectdocu\\PDFlawVO"
  },
  newTaskDetailsCopy: {
    created: "",
    creator: "Sufyan Maher",
    defaultflawparams: [],
    deleted: 0,
    description: "",
    donedate: "",
    flawdate: "",
    flawitems: [],
    flawname: "",
    flawparams: [],
    flawtrades: [],
    flawtype: 1,
    flawurl: "/backend/get?method=flaw&fid=1490",
    fristdate: "",
    noticedate: new Date(),
    notifiedate: "",
    pdflawflags: [],
    pdflawid: 0,
    pdflawstatusrows: [],
    pdprojectid: null,
    pduserid: 0,
    planitems: null,
    projectid: 171,
    responsibleuser: null,
    runid: 0,
    secondfristdate: "0000-00-00",
    selectedtrades: [],
    status: 2,
    _explicitType: "com\\projectdocu\\PDFlawVO"
  }
}


const mutations = {
  setPagesInCreateTask: (state, payload ) => { state.pages =  payload},

  refreshNewTaskDetails: (state, payload) => {
    state.pages = [];
    state.newTaskDetails = {
      created: "",
      creator: "",
      defaultflawparams: [],
      deleted: 0,
      description: "",
      donedate: "",
      flawdate: "",
      flawitems: [],
      flawname: "",
      flawparams: [],
      flawtrades: [],
      flawtype: 1,
      flawurl: "/backend/get?method=flaw&fid=1490",
      fristdate: "",
      noticedate: new Date(),
      notifiedate: "",
      pdflawflags: [],
      pdflawid: 0,
      pdflawstatusrows: [],
      pdprojectid: null,
      pduserid: 0,
      planitems: null,
      projectid: 171,
      responsibleuser: null,
      runid: 0,
      secondfristdate: "0000-00-00",
      selectedtrades: [],
      status: 2,
      _explicitType: "com\\projectdocu\\PDFlawVO"
    }
  },
  setTasksMetaDateFrom: (state, payload) => {state.tasksMetaDateFrom = payload},
  setTasksMetaDateTo: (state, payload) => {state.tasksMetaDateTo = payload},

  setTasksDateFrom: (state, payload) => { state.dateFrom = payload },
  setTasksIsEdit: (state, payload) => { state.isEdit = payload },

  setTasksDateTo: (state, payload) => { state.dateTo = payload },

  toggleTasksDetails: (state,value) => { state.detailsPage = value },
  setTaskDetails: (state, payload) => {
    state.taskDetails = payload
  },
  setEditTaskDetails: (state, payload) => {state.editTaskDetails = payload},
  setTaskDetailsDefaultParams: (state, payload) => {
    state.default_params = state.newTaskDetails.flawparams = payload.defaultflawparams
  },
  setEditTaskSelectedPhotos: (state, payload) => {state.editTaskSelectedPhotos = payload},

  setEditTaskDetailsServices: (state, payload) => {state.editTaskDetails.selectedtrades = payload},
  setNewTaskDetailsServices: (state, payload) => {state.newTaskDetails.selectedtrades = payload},
  setServicesWithCompanies: (state, payload) => {state.servicesWithCompanies = payload},

  setTaskPhotos: (state, payload) => {
    Array.isArray(payload) ? state.taskPhotos = payload : state.taskPhotos.push(payload)
  },
  setTaskEditPhotos: (state, payload) => {
    Array.isArray(payload) ? state.taskEditPhotos = payload : state.taskEditPhotos.push(payload)
  },
  setTaskTempPhotos: (state, payload) => {
    state.taskTempPhotos = payload
  },
  pushTaskTempPhoto: (state, payload) => {
    state.taskTempPhotos.push(payload)
  },
  removeTaskEditPhotos: (state, index) => {
       state.taskEditPhotos.splice(index , 1)
       state.taskTempPhotos.splice(index,1)
  }
}

const actions = {
  // get images Details by ids
  async getImagesByIdsTasksModule({ commit , dispatch },photoParams) {
    let photos = [];
    if (photoParams[3].operands.length > 0){
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "getPhotosOfProject",
          "serviceName": "ProjectdocuService",
          "parameters": photoParams
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        photos = res.data.photos
      });
      await dispatch('getFilesTasksModule', photos)
    }
    else {
      commit("setTaskPhotos",[])
      commit("setTaskEditPhotos",[])
      commit("setTaskTempPhotos",[])
    }
  },

  async getFilesTasksModule ({commit},photos) {
    commit("setTaskPhotos",[])
    commit("setTaskEditPhotos",[])
    commit("setTaskTempPhotos",[])
    for(let x = 0; x < photos.length; x++) {
      await fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photos[x].projectid}&id=${photos[x].pdphotoid}&token=${localStorage.sessiontoken}`,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
          }
        }
      ).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            photos[x].src = reader.result
            const image = {
              pdphotoid: photos[x].pdphotoid,
              src: photos[x].src,
              pdphototext: photos[x].description,
              description: photos[x].description,
              pduserid: photos[x].pduserid,
              runid: photos[x].runid,
              photodate: photos[x].photodate,
              params: photos[x].params,
              origname: photos[x].origname
            }
            const imageCopy = {...image}
            imageCopy.pdphototext = photos[x].pdphototext
            commit("pushTaskTempPhoto",image);
            commit("setTaskPhotos",imageCopy);
            commit("setTaskEditPhotos",imageCopy);
          }
        }).catch(error =>{
          console.log(error);
        });
    }
  },


  async getProjectServicesWithCompany({ commit },id){
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getProjectServicesWithCompany",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res=> {
      if (res.statusText === "OK" || res.status === 200){
        commit('setServicesWithCompanies',res.data)
      }
    });
  },

  async getTaskDetailsById({ commit } , id){
    let task = {};
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getFlawByFlawID",
        "serviceName": "ProjectdocuService",
        "parameters": id,
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
         task = res.data[0];
        if (id[0] === 0 || id[0] === '0'){
          commit('setTaskDetailsDefaultParams',res.data[0]);
        }else {
          commit('setTaskDetails',res.data[0]);
          commit('setEditTaskDetails',res.data[0]);
        }
    });
    return task;
  },


  async updateTaskDetails({ commit } , payload){
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
 {
        methodName: "createFlaw",
        serviceName: "ProjectdocuService",
        parameters :[payload]
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if (res.statusText === 'OK' || res.status === 200){
          if (payload.pdflawid === 0 || payload.pdflawid === '0'){
            this._vm.$toast.success('Neuer Mangel erstellt')
          }else {
            this._vm.$toast.success('Mangel aktualisiert')
          }
        }
    })
  },

  async deleteFlaw({ commit }, id) {
    commit( 'loading', true )
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "deleteFlaw",
        "serviceName": "ProjectdocuService",
        "parameters": [id]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.status === 200 || res.statusText === 'OK'){
        this._vm.$toast.success('Mangel gelöscht')
      }
    })
    commit( 'loading', false )
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tasks.js